<template>
  <v-form @submit="forget" id="reset_fields">
    <div class="flex layout-row pt-4" style="max-width: 700px;min-height:450px;">
      <ValidationObserver ref="LoginForm" v-slot="{ errors, valid, pristine, reset }" class="layout-column flex">
        <div class="flex px-8 pt-5 layout-column">
          <validation-provider tag="div" ref="Benutzername" name="Benutzername" rules="" v-slot="{ errors }">
            <v-text-field
              v-model="model.login"
              :error-messages="errors[0]"
              color="white"
              @keydown="resetAlert"
              dark
              outlined
              placeholder=" "
              prepend-inner-icon="supervised_user_circle"
              :label="$t('AUTH.FORGOT_PASSWORD.USERNAME')"
              class="mx-2"
              :disabled="getCookieQuestionVisibility.visibility"
            ></v-text-field>
          </validation-provider>
          <div class="layout-row layout-align-center-center">
            <span class="white--text mb-7">{{ $t('OR') }}</span>
          </div>
          <validation-provider tag="div" ref="Email" name="Email" rules="email" v-slot="{ errors }">
            <v-text-field
              v-model="model.email"
              :error-messages="errors[0]"
              color="white"
              @keydown="resetAlert"
              dark
              outlined
              placeholder=" "
              prepend-inner-icon="email"
              :label="$t('AUTH.FORGOT_PASSWORD.EMAIL')"
              class="mx-2"
              :disabled="getCookieQuestionVisibility.visibility"
            ></v-text-field>
          </validation-provider>
          <div class="layout-row mx-2 my-5 pa-3 green white--text layout-align-start-center" style="border-left: 8px solid #5cd060 !important;border-radius: 3px;" v-if="serverEmailSent && pristine">
            <v-avatar>
              <v-icon dark large>error_outline</v-icon>
            </v-avatar>
            <div class="flex layout-column layout-align-start-center ml-2">
              <p class="ma-0">{{ $t('AUTH.FORGOT_PASSWORD.LINK_SENT') }}</p>
            </div>
          </div>
        </div>
        <v-divider class="mx-5"></v-divider>
        <div class="pa-2 d-flex flex-row">
          <div class="grow mr-1">
            <lx-btn classes="mr-1 text-none"
                    type="submit"
                    color="green"
                    block
                    :disabled="getCookieQuestionVisibility.visibility || pristine || errors['Email'] && errors['Email'].length > 0"
                    :label="$t('AUTH.FORGOT_PASSWORD.BUTTONS.REQUEST')"
                    :tooltip="$t('AUTH.FORGOT_PASSWORD.BUTTONS.REQUEST_HINT')"></lx-btn>
          </div>
          <lx-btn classes="mr-1 text-none" @click="clearForm(reset)"
                  color="white"
                  :disabled="pristine"
                  icon="clear"
                  :tooltip="$t('AUTH.FORGOT_PASSWORD.BUTTONS.RESET_HINT')"></lx-btn>
        </div>
      </ValidationObserver>
    </div>
  </v-form>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default Vue.component('ForgotPasswordComponent', {
  data () {
    return {
      model: {},
      loading: false,
      serverEmailSent: false,
      serverError: false
    }
  },
  methods: {
    resetAlert () {
      this.serverEmailSent = false
    },

    /**
     *  Send mail to user for changing password
     *
     *  Param for backend is user object with login name and/or email address
     *
     * @param ev
     */
    forget (ev) {
      if (this.loading) return

      ev.preventDefault() // wichtig damit Formular mit Enter abgeschickt werden kann

      this.loading = true

      let query = { login: null }

      if (this.model.login && this.model.email) {
        query.login = this.model.email
      } else {
        query.login = this.model.login || this.model.email
      }


      axios.post('/forgotPassword', query)
        .then(() => {
          this.serverEmailSent = true
        })
        .catch(() => {
          this.serverError = true
        })
        .finally(() => {
          this.loading = false
          this.model = {}
          if (this.$refs.LoginForm) {
            this.$refs.LoginForm.reset()
          }
        })
    },

    /**
     * Clear model an view of messages
     */
    clear () {
      this.model = {}
      this.serverEmailSent = false
      this.serverError = false
    },

    clearForm (reset) {
      reset()
      this.model = {}
      this.loginError = false
    }
  }
})
</script>
